import { roles } from "constants/index";

export const rolesSendNoti = [roles.qs, roles.departmentManager, roles.regionManager, roles.viceRegionManager];

export const rolesNotShowAction = [roles.shopManager]

export const rolesCanMarkAsRead = [roles.shopManager]